export const ROW_GUTTER = 16;
export const NOTIFICATION_PLACEMENT = 'bottomRight';
export const DECIMAL_SEPARATOR = '.';
